   $(document).ready(function(){
        $(".new_arrivlas .owl-carousel").owlCarousel({
            items: 2,
            loop: false,
            margin: 15,
            autoplay: false,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:2
                },
                1000:{
                    items:2
                }
            }
        });
    });



document.addEventListener('DOMContentLoaded', function () {
  const loadMoreBtn = document.getElementById('load-more-btn');

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      const nextPageUrl = loadMoreBtn.getAttribute('data-next-page');

      // If data-next-page is empty, hide the button
      if (!nextPageUrl) {
        loadMoreBtn.style.display = 'none';
        return;
      }

      // Fetch the next page's products
      fetch(nextPageUrl)
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, 'text/html');

          // Extract the products and next page button
          const newProducts = doc.querySelectorAll('#product-grid > *');
          const nextPageButton = doc.querySelector('#load-more-btn');

          // Append the new products to the grid
          const productGrid = document.getElementById('product-grid');
          newProducts.forEach(product => productGrid.appendChild(product));

          // Update or hide the Load More button
          if (nextPageButton) {
            loadMoreBtn.setAttribute('data-next-page', nextPageButton.getAttribute('data-next-page'));
          } else {
            loadMoreBtn.style.display = 'none';
          }
        })
        .catch(error => console.error('Error loading more products:', error));
    });
  }
});


jQuery(window).scroll(function(){
  var sticky = jQuery('.header-wrapper'),
      scroll = jQuery(window).scrollTop();

  if (scroll >= 100) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});


let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");

console.log(items);

items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);

    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });

    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});


jQuery(document).ready(function($) {
    $(".read-more").click(function() {
        var parent = $(this).closest("div, section, article");
        var moreText = parent.find(".more-text"); 
        moreText.slideToggle(400, function() {
            if (moreText.is(":visible")) {
                parent.find(".read-more").text("Read Less");
            } else {
                parent.find(".read-more").text("Read More");
            }
        });
    });
});



